import { Reveal, SectionHeading } from "./Reveal";
import { PROCESS } from "@/data/content";

const Process = () => (
  <section
    id="how-we-work"
    data-testid="process-section"
    className="border-t border-white/5 bg-[#0D1220]"
  >
    <div className="mx-auto max-w-7xl px-4 py-24 sm:px-8 lg:px-16 lg:py-32">
      <SectionHeading number="04" label="How We Work" title="A disciplined process" />

      <div className="mt-16">
        {PROCESS.map((step, i) => (
          <Reveal key={step.step} delay={i * 0.08}>
            <div
              data-testid={`process-step-${step.step}`}
              className="group grid grid-cols-[64px_1fr] gap-6 border-b border-white/10 py-10 transition-colors duration-500 first:border-t hover:bg-[#111827]/60 sm:grid-cols-[120px_240px_1fr] sm:gap-10 sm:px-6"
            >
              <span className="font-display text-4xl font-light text-[#F26122]/50 transition-colors duration-300 group-hover:text-[#F26122] sm:text-5xl">
                {step.step}
              </span>
              <h3 className="font-display text-2xl font-light text-slate-100 sm:text-3xl">
                {step.title}
              </h3>
              <p className="col-span-2 max-w-2xl text-sm font-light leading-relaxed text-slate-400 sm:col-span-1 sm:text-base">
                {step.description}
              </p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <p
          data-testid="process-disclaimer"
          className="mt-10 max-w-2xl border-l border-[#F26122]/40 pl-5 text-xs font-light italic leading-relaxed text-slate-500"
        >
          Funding is subject to the respective capital provider&rsquo;s
          independent evaluation, due diligence and approval.
        </p>
      </Reveal>
    </div>
  </section>
);

export default Process;
